export default __webpack_public_path__ + "static/media/logo.7e5095f4.svg";